define('threadsListThreadsView',[
  'app',
  'module',
  'underscore',
  'tableView',
  'threadsListThreadView',
  'threadsThreadView',
  'entities/threads'
], function (
    App,
    Module,
    _,
    TableView,
    ListThreadView,
    ThreadDetailView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'threads-table-view ' + TableView.prototype.className,
    pageSize: 20,
    pageMode: 'pagination',
    header: false,
    selectable: true,
    footerMaxPages: 5,
    searchValue: '',
    showPaginator: true,
    showPageSizeSeletor: false,

    init: function() {
      this.folder = undefined;
      this.mailSecId = undefined;
      this.messageCount = 0;
      this.selectedLabels = [];
    },

    setFields: function() {
      var fields = [];

      fields.push({
        name: 'Thread',
        className: 'thread',
        view: ListThreadView
      });

      return fields;
    },

    setMailSecId: function(secId) {
      this.mailSecId = secId;
      this.trigger('change:mailSecId', secId);
      this.refresh();
    },

    setFolder: function(folderId) {
      this.folder = folderId;
      this.refresh();
    },

    fetch: function(first, pageSize) {
      var defer = $.Deferred();

      if(this.folder === undefined || this.mailSecId === undefined)
        return defer.resolve([]);

      if(!first) first = 0;
      if(pageSize) this.pageSize = pageSize;

      var params = {};
      params.folder = this.folder;
      params.page = Math.ceil(first/this.pageSize);
      params.size = this.pageSize;
      params.sort = 'lastMessageDate,desc';

      // Build search query combining text search and label filters
      var searchParts = [];
      if (this.searchValue) {
        searchParts.push(this.searchValue);
      }
      if (this.selectedLabels && this.selectedLabels.length > 0) {
        _.each(this.selectedLabels, function(labelId) {
          searchParts.push('label:' + labelId);
        });
      }
      params.search = searchParts.join(' ');

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
          type: 'GET',
          url: App.request('threads:get-url', this.mailSecId, params),
          headers: {
              'Cache-Control': 'no-cache'
          },
          success: _.bind(function (items) {
              var models = [];

              try {
                if (items && items.pageable) {
                  this.pageSize = items.pageable.pageSize || this.pageSize;
                  if(items.totalElements)
                    this.messageCount = items.totalElements;
                  if (typeof items.pageable.pageNumber !== 'undefined' && items.pageable.pageNumber !== null) {
                    this.footerView.setCurrentPage(items.pageable.pageNumber + 1);
                  }
                }

                var content = (items && items.content) ? items.content : [];
                _.each(content, _.bind(function(item) {
                  var model = App.request('threads:model', item);
                  models.push(model);
                }, this));
              } catch (e) {
                models = [];
              }

              defer.resolve(models, this.messageCount);
          }, this),
          error: function() {
              defer.resolve([]);
          }
      });

      return defer.promise();
    },

    fetchCount: function() {
      var defer = $.Deferred();
      defer.resolve(this.messageCount);
      return defer.promise();
    },

    onRowClick: function(view) {
      this.threadDetailView = new ThreadDetailView({
        model: view.model,
        mailSecId: this.mailSecId,
        parentView: this,
        // Minimise the reply/draft composer by default — like the Sales Inbox.
        collapsibleReply: true
      });
      this.options.parentView.options.parentView.getRegion('threadRegion').show(this.threadDetailView);
    },

    search: function(value) {
      this.searchValue = value;
      this.refresh();
    },

    clearSearch: function() {
        this.searchValue = '';
    },

    filterByLabels: function(labels) {
      this.selectedLabels = labels || [];
      this.refresh();
    },

    clearLabelsFilter: function() {
      this.selectedLabels = [];
      this.refresh();
    }
  });
});

